
export interface IEndInfo {
    head: number;
    tail: number;
}

class BaseLine {
    public controlValues: number[];
    public defaultValue: {
        controlValues: number[];
    };
    protected startPos: {
        x: number;
        y: number;
    };
    protected endPos: {
        x: number;
        y: number;
    };

    public constructor() {
        this.controlValues = [];
        this.defaultValue = {
            controlValues: [],
        };
        this.startPos = {
            x: 0,
            y: 0,
        };
        this.endPos = {
            x: 0,
            y: 0,
        };
    }

    public getControlValues = () => this.controlValues;

    public svgPathInRect = (
        x: number, y: number, w: number, h: number,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _controlValues: number[], _endInfo: IEndInfo,
    ): string => (
        `M${x} ${y} L${x + w} ${y} L${x + w} ${y + h} L${x} ${y + h} Z`
    );

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getControlPoints = (_w: number, _h: number): Array<{x: number; y: number}> => [];

    public getHeadPos = () => this.startPos;

    public getTailPos = () => this.endPos;

    /**
     *
     * @param controlPointIndex 当前正在移动第几个控制点
     * @param newPosWithRect
     */
    public controlValuesWithControlPointChange = (
        controlPointIndex: number,
        oldControlValues: number[],
        newPosWithRect: { x: number; y: number },
        w: number, h: number,
    ): number[] => {
        let value = 0;
        const controlValues = oldControlValues;
        if (controlPointIndex % 2 === 0) {
            if (!w) {
                return controlValues;
            }
            value = newPosWithRect.x / w;
            oldControlValues.splice(controlPointIndex, 1, value);
        } else {
            if (!h) {
                return controlValues;
            }
            value = newPosWithRect.y / h;
            oldControlValues.splice(controlPointIndex, 1, value);
        }
        return controlValues;
    };
}

export default BaseLine;
